import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { RcddbLookupBr } from '@shared/models/filetype/RcddbLookupBr';
import { FwbsResultEdit } from '@shared/models/fwmbsResultEdit';
import { DeterminedResultEdit } from '@shared/models/determinedResultEdit';
import { ErrorHandlerService } from './errorHandler/error-handler.service';
import { StorageService } from '@core/services/storage.service';
import { sessionStorageKeys } from '@shared/constants/SessionStorageKeys';
import { SteuerdatenService } from './steuerdaten.service';


@Injectable({
  providedIn: 'root',
})
export class RcddbService {
  fwmbsRows: FwbsResultEdit[] = [];
  determinedRows: DeterminedResultEdit[] = [];
  orignalDeterminedRows: DeterminedResultEdit[] = [];
  selected: DeterminedResultEdit[] = [];
  rcddbLookup!: RcddbLookupBr[];
  isDataValid: boolean ;

  constructor(
    private readonly notificationService: ErrorHandlerService,
    private readonly storageService: StorageService,
    private readonly steuerdatenService: SteuerdatenService

  ) {}

fetchfromAPI(fwmbsList: String[]): Observable<boolean> {
  const rows_no = fwmbsList && fwmbsList.join(' ').split(' ').map(item => item.trim()).filter(item => item).length;
  const fwbsList = fwmbsList
    .filter(item => item && item.trim() !== '')
    .map(item => item.trim());

  return this.fetchRcddbLookup(fwbsList).pipe(
    map((rcddbLookupData: RcddbLookupBr[]) => {
      if (rcddbLookupData && rcddbLookupData.length === rows_no) {
        this.isDataValid = true;
      } else {
        this.isDataValid = false;
      }
      return this.isDataValid;
    }),
    catchError((error: HttpErrorResponse) => {
      this.notificationService.handleServerErrorNotification(
        error,
        'global.bdp-status.service-down'
      );
      return of(false);
    })
  );
}

private fetchRcddbLookup(fwmbsList: String[]): Observable<RcddbLookupBr[]> {
  const rows = fwmbsList;
  const flashForm = this.storageService.getData(sessionStorageKeys.flashForm) || {};
  const sdpName = flashForm.sdpName;
  const xentryRelease = flashForm.xentryReleases;
  const fwmbsValues = rows && rows.join(' ').replace(/\s+/g, ',');
  return this.steuerdatenService.getRcddbLookup(sdpName, [fwmbsValues], xentryRelease);
}
}